module.exports = __webpack_public_path__ + "static/img/autumn_banner.37369687.jpg";